import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCsv = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("mask", {
		id: "mask0_6841_6159",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 32,
		height: 32,
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 16,
			fill: "white"
		}), /* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 16,
			stroke: "#D186FF"
		})]
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_6841_6159)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M27.7407 0.463759C26.6235 0.462678 25.5524 0.018384 24.7625 -0.771573C23.9725 -1.56153 23.5282 -2.63263 23.5271 -3.7498V-9.6001H4.69905C3.24066 -9.6001 1.84201 -9.02074 0.810772 -7.98951C-0.220463 -6.95827 -0.799805 -5.55965 -0.799805 -4.10126V29.0471C-0.797639 30.5041 -0.21734 31.9007 0.813659 32.9301C1.84466 33.9596 3.24208 34.5378 4.69905 34.5378H27.2993C28.0216 34.5381 28.7369 34.3961 29.4043 34.1199C30.0716 33.8436 30.6781 33.4386 31.1889 32.928C31.6997 32.4173 32.105 31.8111 32.3814 31.1438C32.6579 30.4765 32.8002 29.7613 32.8002 29.039V0.455578L27.7407 0.463759Z",
				fill: "#F1F7FE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.28897 19.9749V21.2225H8V19.9749H9.28897Z",
				fill: "#0E457E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.92 16.5366C14.3555 16.8891 14.6514 17.385 14.7547 17.9357H13.4365C13.3485 17.7072 13.1931 17.5109 12.9907 17.373C12.7779 17.2334 12.5276 17.162 12.2731 17.1682C12.1054 17.1631 11.9387 17.1966 11.7859 17.2661C11.6331 17.3356 11.4984 17.4393 11.392 17.5691C11.1555 17.8749 11.0365 18.2553 11.0564 18.6413C11.0363 19.0258 11.1555 19.4046 11.392 19.7083C11.4988 19.8374 11.6337 19.9403 11.7865 20.0092C11.9392 20.0781 12.1057 20.1111 12.2731 20.1058C12.5276 20.112 12.7779 20.0406 12.9907 19.901C13.193 19.7659 13.3496 19.5727 13.4399 19.3469H14.7581C14.6527 19.8958 14.3572 20.3899 13.9235 20.7425C13.4582 21.1002 12.8819 21.283 12.2955 21.2588C11.8336 21.269 11.3776 21.1542 10.9755 20.9267C10.5988 20.7088 10.2938 20.3859 10.0979 19.9974C9.88576 19.5755 9.77945 19.1083 9.78811 18.6361C9.77924 18.1634 9.88556 17.6956 10.0979 17.2731C10.2938 16.8846 10.5988 16.5617 10.9755 16.3439C11.3776 16.1163 11.8336 16.0016 12.2955 16.0117C12.8817 15.9916 13.4565 16.1772 13.92 16.5366Z",
				fill: "#0E457E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.95 20.5221C18.8017 20.7588 18.5893 20.9486 18.3374 21.0693C18.0308 21.2129 17.6948 21.2824 17.3565 21.2724C16.8469 21.2931 16.3448 21.1448 15.9281 20.8508C15.7441 20.7125 15.5935 20.5346 15.4874 20.3302C15.3814 20.1259 15.3226 19.9004 15.3155 19.6703H16.6423C16.6515 19.8437 16.7259 20.0071 16.8505 20.128C16.9738 20.2434 17.1378 20.3053 17.3066 20.3001C17.4449 20.3072 17.5806 20.2603 17.6852 20.1693C17.7305 20.1245 17.7661 20.0708 17.7898 20.0115C17.8135 19.9523 17.8247 19.8889 17.8228 19.8251C17.8244 19.7649 17.814 19.7049 17.7921 19.6488C17.7703 19.5926 17.7374 19.5414 17.6955 19.4982C17.6051 19.4064 17.4975 19.3333 17.3788 19.2831C17.2515 19.2263 17.0777 19.1591 16.854 19.0817C16.5808 18.9918 16.3141 18.8838 16.0554 18.7582C15.8429 18.6483 15.6604 18.4882 15.5237 18.2918C15.3664 18.0535 15.2887 17.7716 15.3017 17.4864C15.2947 17.2037 15.3759 16.9258 15.534 16.6913C15.6966 16.4623 15.9202 16.2834 16.1794 16.1751C16.4792 16.0537 16.8008 15.9952 17.1241 16.003C17.613 15.9771 18.0958 16.1212 18.4906 16.4108C18.659 16.5474 18.797 16.7179 18.8954 16.9112C18.9938 17.1044 19.0505 17.3162 19.0619 17.5328H17.7144C17.6978 17.3815 17.6326 17.2396 17.5286 17.1285C17.4747 17.0775 17.4112 17.0379 17.3417 17.0122C17.2722 16.9865 17.1982 16.9751 17.1241 16.9787C16.9955 16.9721 16.8691 17.0139 16.7696 17.0957C16.7231 17.1395 16.6869 17.1932 16.6637 17.2527C16.6405 17.3122 16.6308 17.3762 16.6354 17.4399C16.6339 17.497 16.6438 17.5537 16.6645 17.6069C16.6852 17.6601 16.7162 17.7086 16.7559 17.7497C16.8412 17.8395 16.9443 17.9104 17.0587 17.9579C17.1792 18.0113 17.3547 18.0801 17.575 18.1627C17.8532 18.2522 18.1241 18.3627 18.3856 18.4931C18.6 18.6084 18.7844 18.7723 18.9242 18.9716C19.0838 19.2128 19.1627 19.4984 19.1497 19.7873C19.1509 20.0458 19.0819 20.2998 18.95 20.5221Z",
				fill: "#0E457E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.8108 16.0701L22.0722 19.9473L23.3336 16.0701H24.6673L22.8741 21.2225H21.2634L19.4771 16.0701H20.8108Z",
				fill: "#0E457E"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 8,
				y: -2,
				width: 23,
				height: 17,
				stroke: "#B3E5FC",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.8999 9.1V8.5H25.0999V9.1H6.8999Z",
				stroke: "#B3E5FC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.8999 5.90005V5.30005H25.0999V5.90005H6.8999Z",
				stroke: "#B3E5FC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.1001 2.7001V2.1001H24.3001V2.7001H6.1001Z",
				stroke: "#B3E5FC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.1104 11.0165V-2.34717H19.5066V11.0165H19.1104Z",
				stroke: "#B3E5FC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.1567 11.0165V-2.34717H11.553V11.0165H11.1567Z",
				stroke: "#B3E5FC"
			})
		]
	})]
});
export default SvgCsv;
